import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=6e1ef6a8"
import script from "./Legend.vue?vue&type=script&setup=true&lang=ts"
export * from "./Legend.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Legend.vue?vue&type=style&index=0&id=6e1ef6a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports